/* Lintico Mode - Maatquiz "Welke maat past mij?" (overgenomen uit het live thema, aangepast aan de Leo-productpagina) */
(function () {
  if (window.__lmqInit) return;
  window.__lmqInit = true;

  /* Zweedse teksten (alleen actief als de pagina in het Zweeds is) */
  var SV = document.documentElement.lang === 'sv' ? {
    "Welke maat past mij?": "Vilken storlek passar mig?",
    "Ja, die past meestal goed": "Ja, den brukar passa bra",
    "Past meestal goed": "Brukar passa bra",
    "Soms is die wat krap": "Ibland sitter den lite tajt",
    "Soms wat krap": "Ibland lite tajt",
    "Soms is die wat ruim": "Ibland sitter den lite löst",
    "Soms wat ruim": "Ibland lite löst",
    "Nauwsluitend": "Åtsittande",
    "Dicht op het lichaam": "Nära kroppen",
    "Normaal": "Normal",
    "Zoals het model bedoeld is": "Så som modellen är tänkt",
    "Ruim": "Rymlig",
    "Losjes en extra comfortabel": "Ledig och extra bekväm",
    "Vorige stap": "Föregående steg",
    "Sluiten": "Stäng",
    "Stap {0} van 3": "Steg {0} av 3",
    "Welke maat draag je meestal?": "Vilken storlek brukar du ha?",
    "Kies de maat die je bij andere merken het vaakst draagt.": "Välj den storlek du oftast har hos andra märken.",
    "Deze kleur is helaas in geen enkele maat meer op voorraad. Kies een andere kleur en probeer het opnieuw.": "Den här färgen finns tyvärr inte längre i lager i någon storlek. Välj en annan färg och försök igen.",
    "Liever zelf meten? Bekijk de maattabel": "Vill du hellre mäta själv? Se storlekstabellen",
    "Valt maat {0} bij jou meestal goed?": "Brukar storlek {0} passa dig bra?",
    "Hoe wil je dat dit model valt?": "Hur vill du att den här modellen ska sitta?",
    "Zo houden we rekening met hoe jouw maat normaal valt.": "Så tar vi hänsyn till hur din storlek brukar sitta.",
    "Iedereen draagt kleding anders. Kies wat jij fijn vindt.": "Alla bär kläder olika. Välj det du tycker om.",
    "Eén maat groter dan je gewoonlijke maat, voor wat extra ruimte.": "En storlek större än din vanliga storlek, för lite extra utrymme.",
    "Eén maat kleiner dan je gewoonlijke maat, voor een nauwere pasvorm.": "En storlek mindre än din vanliga storlek, för en tightare passform.",
    "Dat is dezelfde maat die je meestal draagt.": "Det är samma storlek som du brukar ha.",
    "Jouw aanbeveling": "Din rekommendation",
    "Maat {0}": "Storlek {0}",
    "Op basis van je antwoorden raden we maat <b>{0}</b> aan voor dit model. ": "Utifrån dina svar rekommenderar vi storlek <b>{0}</b> för den här modellen. ",
    "Maat {0} is in deze kleur uitverkocht. Maat {1} komt het dichtst in de buurt.": "Storlek {0} är slutsåld i den här färgen. Storlek {1} är närmast.",
    "Meestal": "Brukar ha",
    "Pasvorm": "Passform",
    "Voorkeur": "Önskemål",
    "Kies maat {0}": "Välj storlek {0}",
    "Opnieuw beginnen": "Börja om", "Voeg maat {0} toe aan winkelwagen": "Lägg storlek {0} i varukorgen",
    "Past het toch niet? Je kunt 30 dagen retourneren.": "Passar den ändå inte? Du kan returnera inom 30 dagar."
  } : {};
  var ADD = true; function L(s) { return SV[s] || s; }
  function F(s, a, b) { return L(s).replace('{0}', a).replace('{1}', b === undefined ? '' : b); }

  var LEGEND_RE = /^\s*(maat|maten|grootte|size|storlek)/i;
  var SIZE_RE = /^\s*(\d{0,2}x{0,3}[sml]\b|\d?x{1,3}[sl]\b|\d+xl\b|\d{2}\b)/i;
  var ICONS = {
    tape: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M21.3 15.3a2.4 2.4 0 0 1 0 3.4l-2.6 2.6a2.4 2.4 0 0 1-3.4 0L2.7 8.7a2.41 2.41 0 0 1 0-3.4l2.6-2.6a2.41 2.41 0 0 1 3.4 0Z"/><path d="m14.5 12.5 2-2"/><path d="m11.5 9.5 2-2"/><path d="m8.5 6.5 2-2"/><path d="m17.5 15.5 2-2"/></svg>',
    back: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m15 18-6-6 6-6"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12"/></svg>',
    check: '<svg viewBox="0 0 12 12" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 6.2l2.2 2.2 4.8-4.8"/></svg>'
  };
  var FIT_OPTS = [
    { key: 'ok', title: L('Ja, die past meestal goed'), label: L('Past meestal goed'), shift: 0 },
    { key: 'tight', title: L('Soms is die wat krap'), label: L('Soms wat krap'), shift: 1 },
    { key: 'loose', title: L('Soms is die wat ruim'), label: L('Soms wat ruim'), shift: -1 }
  ];
  var PREF_OPTS = [
    { key: 'fitted', title: L('Nauwsluitend'), desc: L('Dicht op het lichaam'), shift: -1 },
    { key: 'regular', title: L('Normaal'), desc: L('Zoals het model bedoeld is'), shift: 0 },
    { key: 'relaxed', title: L('Ruim'), desc: L('Losjes en extra comfortabel'), shift: 1 }
  ];

  var state = { step: 1, usual: null, fit: null, pref: null };
  var sizes = [];
  var overlay, dialog, lastTrigger;

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function labelName(label) {
    if (!label) return '';
    if (label.hasAttribute('data-lmq-name')) return label.getAttribute('data-lmq-name');
    var txt = '';
    for (var i = 0; i < label.childNodes.length; i++) { var n = label.childNodes[i]; if (n.nodeType === 3) txt += n.textContent; }
    txt = txt.trim() || label.textContent.trim();
    label.setAttribute('data-lmq-name', txt);
    return txt;
  }

  /* Zoekt de maatkeuze op de productpagina: .lp-opt met label Maat / Grootte / Size */
  function findSizeFieldset() {
    var root = document.querySelector('[data-lp]');
    if (!root) return null;
    var sets = root.querySelectorAll('.lp-opt[data-lp-option]');
    for (var i = 0; i < sets.length; i++) {
      if (LEGEND_RE.test(labelName(sets[i].querySelector('.lp-opt__label')))) return sets[i];
    }
    return null;
  }

  function readSizes(fs) {
    var list = [];
    if (!fs) return list;
    var items = fs.querySelectorAll('.lp-btn[data-value]');
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var v = (it.getAttribute('data-value') || '').trim();
      if (!v || !SIZE_RE.test(v) || /vergelijkbaar/i.test(v)) continue;
      list.push({ value: v, available: !it.classList.contains('is-unavailable') && !it.disabled, el: it });
    }
    return list;
  }

  function parseLabel(v) {
    var m = v.match(/^(.+?)\s*\(\s*(?:EU\s*)?(.+?)\s*\)\s*$/i);
    if (m) return { big: m[1].trim(), small: m[2].trim() };
    var i = v.indexOf('/');
    if (i > 0 && i < v.length - 1) return { big: v.slice(0, i).trim(), small: v.slice(i + 1).trim() };
    return { big: v, small: '' };
  }

  function ensureTrigger() {
    var fs = findSizeFieldset();
    if (!fs || fs.querySelector('.lmq-trigger')) return;
    var sz = readSizes(fs);
    if (sz.length < 2 || !sz.some(function (s) { return s.available; })) return;
    var label = fs.querySelector('.lp-opt__label');
    if (!label) return;
    labelName(label);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lmq-trigger';
    btn.setAttribute('aria-haspopup', 'dialog');
    btn.innerHTML = ICONS.tape + '<span>' + L('Welke maat past mij?') + '</span>';
    btn.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); open(btn); });
    label.appendChild(btn);
  }

  function buildOverlay() {
    if (overlay) return;
    overlay = document.createElement('div');
    overlay.className = 'lmq-overlay';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.innerHTML = '<div class="lmq-dialog" role="dialog" aria-modal="true" aria-labelledby="lmq-title" tabindex="-1"></div>';
    dialog = overlay.firstChild;
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
    document.addEventListener('keydown', function (e) {
      if (!overlay.classList.contains('is-open')) return;
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      if (e.key === 'Tab') trapFocus(e);
    });
    document.body.appendChild(overlay);
  }

  function trapFocus(e) {
    var f = dialog.querySelectorAll('button:not(.is-hidden):not([disabled])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function open(trigger) {
    buildOverlay();
    lastTrigger = trigger || null;
    sizes = readSizes(findSizeFieldset());
    if (state.usual && !sizes.some(function (s) { return s.value === state.usual; })) state = { step: 1, usual: null, fit: null, pref: null };
    if (state.step !== 4) state.step = 1;
    render();
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lmq-locked');
    requestAnimationFrame(function () { overlay.classList.add('is-open'); focusFirst(); });
  }

  function close() {
    if (!overlay) return;
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lmq-locked');
    if (lastTrigger && document.body.contains(lastTrigger)) lastTrigger.focus({ preventScroll: true });
  }

  function focusFirst() {
    var el = dialog.querySelector('.is-selected') || dialog.querySelector('.lmq-tile, .lmq-option, .lmq-cta');
    (el || dialog).focus({ preventScroll: true });
  }

  function go(step) { state.step = step; render(); focusFirst(); }

  function recommend() {
    var idx = -1;
    for (var i = 0; i < sizes.length; i++) if (sizes[i].value === state.usual) idx = i;
    var fit = FIT_OPTS.filter(function (o) { return o.key === state.fit; })[0] || FIT_OPTS[0];
    var pref = PREF_OPTS.filter(function (o) { return o.key === state.pref; })[0] || PREF_OPTS[1];
    var shift = Math.max(-1, Math.min(1, fit.shift + pref.shift));
    var target = Math.max(0, Math.min(sizes.length - 1, idx + shift));
    var rec = target;
    if (!sizes[target].available) {
      rec = -1;
      var dir = shift < 0 ? -1 : 1;
      for (var d = 1; d < sizes.length && rec < 0; d++) {
        var a = target + dir * d, b = target - dir * d;
        if (a >= 0 && a < sizes.length && sizes[a].available) rec = a;
        else if (b >= 0 && b < sizes.length && sizes[b].available) rec = b;
      }
      if (rec < 0) rec = idx;
    }
    return { size: sizes[rec], wanted: sizes[target], shift: target - idx, fit: fit, pref: pref };
  }

  function header(stepLabel, showBack, done) {
    var prog = '';
    for (var i = 1; i <= 3; i++) prog += '<span class="' + (i <= done ? 'is-done' : '') + '"></span>';
    return '<div class="lmq-grip" aria-hidden="true"></div>' +
      '<div class="lmq-top">' +
        '<button type="button" class="lmq-icon-btn' + (showBack ? '' : ' is-hidden') + '" data-lmq="back" aria-label="' + L('Vorige stap') + '"' + (showBack ? '' : ' tabindex="-1" aria-hidden="true"') + '>' + ICONS.back + '</button>' +
        '<div class="lmq-step">' + stepLabel + '</div>' +
        '<button type="button" class="lmq-icon-btn" data-lmq="close" aria-label="' + L('Sluiten') + '">' + ICONS.close + '</button>' +
      '</div>' +
      '<div class="lmq-progress" aria-hidden="true">' + prog + '</div>';
  }

  function render() {
    var s = state.step, html = '';
    if (s === 1) {
      var avail = sizes.filter(function (x) { return x.available; });
      html += header(F('Stap {0} van 3', 1), false, 1);
      html += '<h2 class="lmq-title" id="lmq-title">' + L('Welke maat draag je meestal?') + '</h2>';
      html += '<p class="lmq-sub">' + L('Kies de maat die je bij andere merken het vaakst draagt.') + '</p><div class="lmq-body">';
      if (!avail.length) {
        html += '<p class="lmq-empty">' + L('Deze kleur is helaas in geen enkele maat meer op voorraad. Kies een andere kleur en probeer het opnieuw.') + '</p>';
      } else {
        var cols = avail.length < 4 ? avail.length : 4;
        html += '<div class="lmq-grid' + (avail.length < 4 ? ' lmq-grid--few' : '') + '" style="--lmq-cols:' + cols + '">';
        avail.forEach(function (x) {
          var l = parseLabel(x.value);
          html += '<button type="button" class="lmq-tile' + (state.usual === x.value ? ' is-selected' : '') + '" data-lmq="size" data-value="' + esc(x.value) + '" aria-pressed="' + (state.usual === x.value) + '"><b>' + esc(l.big) + '</b>' + (l.small ? '<small>' + esc(l.small) + '</small>' : '') + '</button>';
        });
        html += '</div>';
      }
      if (findSizeChart()) html += '<button type="button" class="lmq-link" data-lmq="chart">' + L('Liever zelf meten? Bekijk de maattabel') + '</button>';
      html += '</div>';
    } else if (s === 2 || s === 3) {
      var opts = s === 2 ? FIT_OPTS : PREF_OPTS, cur = s === 2 ? state.fit : state.pref;
      html += header(F('Stap {0} van 3', s), true, s);
      html += '<h2 class="lmq-title" id="lmq-title">' + (s === 2 ? F('Valt maat {0} bij jou meestal goed?', esc(state.usual)) : L('Hoe wil je dat dit model valt?')) + '</h2>';
      html += '<p class="lmq-sub">' + (s === 2 ? L('Zo houden we rekening met hoe jouw maat normaal valt.') : L('Iedereen draagt kleding anders. Kies wat jij fijn vindt.')) + '</p>';
      html += '<div class="lmq-body"><div class="lmq-options" role="group">';
      opts.forEach(function (o) {
        var sel = cur === o.key;
        html += '<button type="button" class="lmq-option' + (sel ? ' is-selected' : '') + '" data-lmq="' + (s === 2 ? 'fit' : 'pref') + '" data-value="' + o.key + '" aria-pressed="' + sel + '"><span><b>' + o.title + '</b>' + (o.desc ? '<small>' + o.desc + '</small>' : '') + '</span><i class="lmq-radio">' + ICONS.check + '</i></button>';
      });
      html += '</div></div>';
    } else {
      var r = recommend(), l = parseLabel(r.size.value);
      var why = r.size.value !== r.wanted.value ? '' : r.shift > 0 ? L('Eén maat groter dan je gewoonlijke maat, voor wat extra ruimte.') : r.shift < 0 ? L('Eén maat kleiner dan je gewoonlijke maat, voor een nauwere pasvorm.') : L('Dat is dezelfde maat die je meestal draagt.');
      html += header(L('Jouw aanbeveling'), true, 3);
      html += '<div class="lmq-result"><div class="lmq-size" id="lmq-title">' + esc(l.big) + '</div>' + (l.small ? '<div class="lmq-size-sub">' + F('Maat {0}', esc(l.small)) + '</div>' : '') + '</div>';
      html += '<p class="lmq-explain">' + F('Op basis van je antwoorden raden we maat <b>{0}</b> aan voor dit model. ', esc(r.size.value)) + why + '</p>';
      if (r.size.value !== r.wanted.value) html += '<p class="lmq-note">' + F('Maat {0} is in deze kleur uitverkocht. Maat {1} komt het dichtst in de buurt.', esc(r.wanted.value), esc(r.size.value)) + '</p>';
      html += '<dl class="lmq-summary"><div><dt>' + L('Meestal') + '</dt><dd>' + esc(state.usual) + '</dd></div><div><dt>' + L('Pasvorm') + '</dt><dd>' + r.fit.label + '</dd></div><div><dt>' + L('Voorkeur') + '</dt><dd>' + r.pref.title + '</dd></div></dl>';
      html += '<button type="button" class="lmq-cta" data-lmq="choose" data-value="' + esc(r.size.value) + '">' + (ADD ? F('Voeg maat {0} toe aan winkelwagen', esc(r.size.value)) : F('Kies maat {0}', esc(r.size.value))) + '</button>';
      html += '<button type="button" class="lmq-restart" data-lmq="restart">' + L('Opnieuw beginnen') + '</button>';
      html += '<p class="lmq-fine">' + L('Past het toch niet? Je kunt 30 dagen retourneren.') + '</p>';
    }
    dialog.innerHTML = '<div class="lmq-fade">' + html + '</div>';
    bind();
  }

  function bind() {
    dialog.querySelectorAll('[data-lmq]').forEach(function (el) {
      el.addEventListener('click', function () {
        var a = el.getAttribute('data-lmq'), v = el.getAttribute('data-value');
        if (a === 'close') return close();
        if (a === 'back') return go(state.step === 4 ? 3 : state.step - 1);
        if (a === 'restart') { state = { step: 1, usual: null, fit: null, pref: null }; return go(1); }
        if (a === 'size' || a === 'fit' || a === 'pref') {
          if (a === 'size') state.usual = v; else if (a === 'fit') state.fit = v; else state.pref = v;
          el.parentNode.querySelectorAll('.is-selected').forEach(function (x) { x.classList.remove('is-selected'); x.setAttribute('aria-pressed', 'false'); });
          el.classList.add('is-selected'); el.setAttribute('aria-pressed', 'true');
          setTimeout(function () { go(a === 'size' ? 2 : a === 'fit' ? 3 : 4); }, 180);
          return;
        }
        if (a === 'choose') return choose(v);
        if (a === 'chart') {
          var c = findSizeChart(); close();
          if (c) setTimeout(function () { window.scrollTo({ top: c.getBoundingClientRect().top + window.scrollY - 180, behavior: 'smooth' }); }, 220);
          return;
        }
      });
    });
  }

  /* De maattabel staat in de productbeschrijving (kop "Maatgids" / "Maattabel") */
  function findSizeChart() {
    var els = document.querySelectorAll('.lp-desc h1, .lp-desc h2, .lp-desc h3, .lp-desc h4, .lp-desc h5, .lp-desc h6, .lp-desc strong, .lp-desc b, .lp-desc table');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.tagName === 'TABLE' || /maatgids|maattabel|storleks(guide|tabell)|size\s*(chart|guide)/i.test(el.textContent || '')) return el;
    }
    return null;
  }

  function choose(value) {
    var hit = readSizes(findSizeFieldset()).filter(function (s) { return s.value === value; })[0];
    if (hit) hit.el.click(); if (ADD && hit) setTimeout(function () { var atc = document.querySelector('[data-lp] .lp-atc'); if (atc && !atc.disabled) atc.click(); }, 300);
    close();
  }

  var queued = false;
  function schedule() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; try { ensureTrigger(); } catch (e) {} }); }
  function start() {
    schedule();
    var root = document.querySelector('[data-lp]') || document.body;
    try { new MutationObserver(schedule).observe(root, { childList: true, subtree: true }); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
